import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

type Editorial = {
  id: number;
  judul: string;
  kategori: string;
  kategori_web: string;
  gambar: string;
  deskripsi: string;
  views: string;
  created_at: string;
};

const NewsGrid: React.FC = () => {
  const [news, setNews] = useState<Editorial[]>([]);
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(`${API}/api/editorial-analisis`);
        setNews(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchNews();
  }, [API]);

  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold border-l-4 border-primary pl-3">Isu Nasional</h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.map((item) => (
          <div key={item.id} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition group">
            <div className="overflow-hidden">
              <Link to={`berita/${item.id}`}>
                <img src={item.gambar} alt={item.judul} className="w-full h-44 object-cover group-hover:scale-105 transition duration-500" />
              </Link>
            </div>

            <div className="p-4">
              {/* <span className="text-xs bg-primary text-white px-2 py-1 rounded">{item.kategori}</span> */}

              <Link to={`berita/${item.id}`}>
                <h3 className="font-semibold text-lg mt-2 line-clamp-2 hover:text-primary">{item.judul}</h3>
              </Link>

              <p className="text-sm text-gray-500 mt-2 line-clamp-2" dangerouslySetInnerHTML={{ __html: item.deskripsi }} />

              <div className="text-xs text-gray-400 mt-3 flex justify-between">
                <span>{new Date(item.created_at).toLocaleDateString("id-ID")}</span>

                <span>👁 {item.views}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewsGrid;
